export default __webpack_public_path__ + "assets/models/df8629ae76303cd73f6b787b85cf7ff1.glb";